import CloudItem from "../clouditem";

/**
 * Model holding the auto export settings regarding a singular request
 */
export class BuilderRequestAutoExportSettingsModel {

    /**
     * (Guid) Identifier
     */
    requestGuid!: string;
    /**
     * is auto export enabled\
     */
    enabled: boolean = true;
    /**
     * Where to should the export go? 
     * - NULL & Enabled means to organisation default
     */
    cloudItem: CloudItem | null = null;

}
